// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.portal-topbar {
    background-color: var(--titlebar-bg-color);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 3.5em;
    z-index: 201;
    display: flex;
    align-items: center;
}

span.portal-topbar-text {
    color: var(--titlebar-text-color);
    padding: 0 1.5em 0 0.5em;
    font-weight: bold;
}

img.portal-logo {
    width: auto;
    height: 3.5em;
    flex: 0 0 auto;
}

input.portal-search-field {
    flex: 1 1 auto;
    max-width: 70ch;
}

span.portal-topbar-spacer {
    flex: 1 1 auto;
}

div.portal-topbar div.AppMenu div.appmenu-menu-container {
    height: calc(100vh - 5.75em);
    background-color: var(--app-menu-bg-color);
}

div.portal-topbar div.AppMenu ul.appmenu-menu li:last-child {
    border-bottom: 1px solid var(--app-menu-text-color);
}

div.portal-topbar span.appmenu-label {
    color: var(--titlebar-text-color);
}

div.portal-topbar span.appmenu-icon > span.icon {
    color: var(--titlebar-text-color);
    border-color: var(--titlebar-text-color);
}

div.portal-body {
    background-color: var(--container-bg-color);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 2.25em;
    top: 3.5em;
    z-index: 200;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

div.portal-body-menuvisible div.ThemeList {
    margin-right: 20em;
}

div.portal-body div.ThemeList {
    flex: 1 1 auto;
}

div.portal-bottombar {
    background-color: var(--titlebar-bg-color);
    color: var(--titlebar-text-color);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3em;
    font-size: 75%;
    z-index: 200;
    display: flex;
    align-items: center;
}

div.portal-bottombar-user {
    flex: 0 0 auto;
    padding: 0 0.5em;
}

div.portal-bottombar-user > span.icon {
    margin-right: 0.5em;
}

div.portal-bottombar-links {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 0.5em;
}

div.portal-bottombar-links > a {
    color: var(--titlebar-text-color);
    padding: 0 0.5em;
}

div.portal-bottombar-links > a:not(:last-child) {
    border-right: 1px solid var(--titlebar-text-color);
}
`, "",{"version":3,"sources":["webpack://./plugins/style/Portal.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,OAAO;IACP,QAAQ;IACR,cAAc;IACd,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,iCAAiC;IACjC,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;AACtD","sourcesContent":["div.portal-topbar {\n    background-color: var(--titlebar-bg-color);\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 3.5em;\n    z-index: 201;\n    display: flex;\n    align-items: center;\n}\n\nspan.portal-topbar-text {\n    color: var(--titlebar-text-color);\n    padding: 0 1.5em 0 0.5em;\n    font-weight: bold;\n}\n\nimg.portal-logo {\n    width: auto;\n    height: 3.5em;\n    flex: 0 0 auto;\n}\n\ninput.portal-search-field {\n    flex: 1 1 auto;\n    max-width: 70ch;\n}\n\nspan.portal-topbar-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.portal-topbar div.AppMenu div.appmenu-menu-container {\n    height: calc(100vh - 5.75em);\n    background-color: var(--app-menu-bg-color);\n}\n\ndiv.portal-topbar div.AppMenu ul.appmenu-menu li:last-child {\n    border-bottom: 1px solid var(--app-menu-text-color);\n}\n\ndiv.portal-topbar span.appmenu-label {\n    color: var(--titlebar-text-color);\n}\n\ndiv.portal-topbar span.appmenu-icon > span.icon {\n    color: var(--titlebar-text-color);\n    border-color: var(--titlebar-text-color);\n}\n\ndiv.portal-body {\n    background-color: var(--container-bg-color);\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 2.25em;\n    top: 3.5em;\n    z-index: 200;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n}\n\ndiv.portal-body-menuvisible div.ThemeList {\n    margin-right: 20em;\n}\n\ndiv.portal-body div.ThemeList {\n    flex: 1 1 auto;\n}\n\ndiv.portal-bottombar {\n    background-color: var(--titlebar-bg-color);\n    color: var(--titlebar-text-color);\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 3em;\n    font-size: 75%;\n    z-index: 200;\n    display: flex;\n    align-items: center;\n}\n\ndiv.portal-bottombar-user {\n    flex: 0 0 auto;\n    padding: 0 0.5em;\n}\n\ndiv.portal-bottombar-user > span.icon {\n    margin-right: 0.5em;\n}\n\ndiv.portal-bottombar-links {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 0 0.5em;\n}\n\ndiv.portal-bottombar-links > a {\n    color: var(--titlebar-text-color);\n    padding: 0 0.5em;\n}\n\ndiv.portal-bottombar-links > a:not(:last-child) {\n    border-right: 1px solid var(--titlebar-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
